import React, { useState } from 'react';
import Accordian from '../../../utils/accordion'

const ArabicLearn = (props) => {

    // console.log(props?.learning,"learning");

    let accordions = props?.learning?.learning_accordions;
    let learningData = [];
    learningData = accordions?.map((key, index) => {
        return {
            heading: key.heading,
            content: key.content,
            open: false
        };
    });
    const [learnAccordions, setLearnAccordions] = useState(learningData);

    // const [learnAccordions, setLearnAccordions] = useState([
	// 	{
	// 		heading: `Arabic 1A`,
    //         content:` <h3>Arabic 1A</h3>
    //         <ol>
    //         <li>Converse in the present tense to carry out everyday tasks</li>
    //         <li>Read and Comprehend short pieces of authentic media</li>
    //         <li>Write and type an essay of 100 words or more in the present and past tense</li>
    //         <li>Give an oral report of two minutes or more in the present and past tense</li>
    //         <li>Compare and contrast cultural and linguistic norms of Arabic varieties</li>
    //         <li>Identify, comprehend and perform simple grammatical structures </li>
    //         <li>Interpret and understand selected Hadith and verses of Quran.</li>
    //         <li>Maintain short conversation with a vocabulary of 350 words or more</li>
    //         </ol>`,
	// 		open: false,
	// 	},
	// 	{
	// 		heading: `Arabic 1B`,
    //         content: `<h3>Arabic 1B</h3>
    //             <ol>
    //                 <li>  Narrate events in the past orally and in writing</li>
    //                 <li>Express hopes, intentions, and plans in the future orally and in writing</li>
    //                 <li>Order events by hour, day, and season orally and in writing</li>
    //                 <li>Compare and evaluate views and ideas about relationships, religion, family, education</li>
    //                 <li>Give an oral presentation using complex verbal clauses of 5 minutes or more</li>
    //                 <li>Converse and write with a vocabulary of +600 words on a range of experiences</li>
    //                 <li>Navigate the Modern Arabic Dictionary for grammatical and lexical information</li>
    //                 <li>Describe explicitly how events unfold using complex sentence structures and ideas</li>
    //                 <li>Initiate steady conversation using grammatical structures like complex verb and noun phrases and subordinate clauses</li>
    //             </ol>`
    //         ,
	// 		open: false
	// 	},
	// 	{
	// 		heading: `Arabic 2A`,
    //         content: `<h3>Arabic 2A</h3>
    //             <ol>
    //                 <li> Maintain steady conversation using more sophisticated grammatical structures like locative nouns, active and passive participles, passive constructions</li>
    //                 <li> Communicate at length on celebrations, holidays, travels, history, and immigration in writing and conversation with appropriate stylistic variation.</li>
    //                 <li> Order events by month, year, and date orally and in writing in Gregorian and Islamic calendars</li>
    //                 <li> Read and comprehend a range of modern texts, their social contexts, and author’s voice</li>
    //                 <li> Masterfully examine the Arabic dictionary to establish relations across lexical entries</li>
    //                 <li> Parse and analyze a difficult text for nominal inflection and parts of speech</li>
    //                 <li> Maintain a steady dialogue orally and in writing with a vocabulary of +900 words</li>
    //             </ol>`
    //         ,
	// 		open: false
    //     },
    //     {
	// 		heading: `Arabic 2B`,
    //         content: `<h3>Arabic 2B</h3>
    //             <ol>
    //                 <li> Speak and write stylistically with an expansive range of grammatical competence in modern standard FaSeeHa and classical FuSHa.</li>
    //                 <li> Communicate with ease and flexibility on complex issues like justice, human rights, social and political movements, and modern technology</li>
    //                 <li> Identify and interpret paralinguistic elements of a conversation, such as nuanced speech, tone, mood, irony and sarcasm</li>
    //                 <li> Derive words in conversation and writing without rehearsal and communicate effectively using a vocabulary of +1200 words</li>
    //                 <li> Read multiple genres of literature on the same topic with comprehension and discernment</li>
    //                 <li> Read and comprehend large passages of Islamic literatures such as Quran, Hadith, Sīrah and Fiqh.</li>
    //                 <li> Compose and edit a critical essay in 500 words or more that examines the topics above.</li>
    //             </ol>`
    //         ,
	// 		open: false
	// 	}
	// ]);

    return ( 
        <div className='learn' id='learn'>
            {/*<div className='learn-heading' >What you will learn at each level</div>*/}
            <div className='learn-heading' >{props?.learning.heading ?? ''}</div>
            <Accordian accordions={learnAccordions} setAccordions={setLearnAccordions} />
        </div>
     );
}

export default ArabicLearn; 